













import { Component, Vue, Watch } from 'vue-property-decorator'
import PageTitle from '@/components/template/PageTitle.vue'
import { StatsTemplateBreadcrumbs } from '@/views/elements/stats-template-breadcrumbs'
@Component({
 components: { PageTitle }
})
export default class StatsTemplate extends Vue {

  breadcrumbsObject :Array<object> = [];
  pageTitleText: string = '';

  @Watch('$route', { immediate: true, deep: true })
  updateRoute() {
    switch(this.$router.currentRoute.name) {

      case 'stats-uruchomienia-index':
        this.pageTitleText = 'Statystyki uruchomień';
        this.breadcrumbsObject = StatsTemplateBreadcrumbs.statsUruchomieniaIndexBreadcrumbsObject();
        break;

      case 'stats-uruchomienia-product':
        this.pageTitleText = 'Statystyki uruchomień';
        this.breadcrumbsObject = StatsTemplateBreadcrumbs.statsUruchomieniaProductBreadcrumbsObject(this.$route.params.id);
        break;

      case 'stats-pobrania-index':
        this.pageTitleText = 'Statystyki pobrań';
        this.breadcrumbsObject = StatsTemplateBreadcrumbs.statsPobraniaIndexBreadcrumbsObject();
        break;

      case 'stats-pobrania-product':
        this.pageTitleText = 'Statystyki pobrań';
        this.breadcrumbsObject = StatsTemplateBreadcrumbs.statsPobraniaProductBreadcrumbsObject(this.$route.params.id);
        break;

      case 'stats-uruchomienia-details-index':
        this.pageTitleText = 'Uruchomienia szczegółowo';
        this.breadcrumbsObject = StatsTemplateBreadcrumbs.statsUruchomieniaDetailedProductBreadcrumbsObject(this.$route.params.id);
        break;

      case 'stats-pobrania-details-index':
        this.pageTitleText = 'Pobrania szczegółowo';
        this.breadcrumbsObject = StatsTemplateBreadcrumbs.statsPobraniaDetailedProductBreadcrumbsObject(this.$route.params.id);
        break;

      case 'stats-deklaracje-index':
        this.pageTitleText = 'Statystyki deklaracji';
        this.breadcrumbsObject = StatsTemplateBreadcrumbs.statsDeklaracjeIndexBreadcrumbsObject();
        break;

      case 'stats-deklaracje-product':
        this.pageTitleText = 'Statystyki deklaracji';
        this.breadcrumbsObject = StatsTemplateBreadcrumbs.statsDeklaracjeProductBreadcrumbsObject(this.$route.params.id);
        break;

      case 'stats-deklaracje-details-index':
        this.pageTitleText = 'Deklaracje szczegółowo';
        this.breadcrumbsObject = StatsTemplateBreadcrumbs.statsDeklaracjeDetailedProductBreadcrumbsObject(this.$route.params.id);
        break;

    }


  }

}
